export default __webpack_public_path__ + "fk-cp-zion/img/fk_goto_home_logo_small_5b9cdd.svg";